
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "t": "1642690101039",
    "class": "icon",
    "viewBox": "0 0 1092 1024",
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg",
    "p-id": "641",
    "width": "200",
    "height": "200"
  },
  "children": [
    {
      "tag": "path",
      "attrsMap": {
        "d": "M792.15550571 589.55346012c-32.54137884-13.01655191-22.77896537-58.57448076-22.77896349-61.82861919H766.12240376a205.01068263 205.01068263 0 0 0 55.32034228-139.92792688 120.40309996 120.40309996 0 0 0-120.40309803-130.1655115h-9.76241348a289.61826529 289.61826529 0 0 1 9.76241348 78.09930767 380.73412489 380.73412489 0 0 1-68.33689421 214.77309609v9.76241345l188.73999224 113.89482306c52.06620574 35.79551538 68.3368942 58.57448076 74.84517113 104.13240959h45.55792883a22.77896537 22.77896537 0 0 0 22.7789654-22.77896347v-35.79551732c-3.25413846-22.77896537-16.27068846-68.3368942-172.46930569-130.1655115z m-191.99413076 26.03310192c-45.55792885-19.52482692-32.54137884-78.09930768-32.54137882-84.60758265h-3.25413654a283.10999029 283.10999029 0 0 0 74.84516923-191.99413261c0-113.89482305-74.84516922-178.9775807-165.96102881-178.97757881s-165.96102881 65.08275577-165.96102881 178.97757881a283.10999029 283.10999029 0 0 0 74.84516921 191.99413261h-3.25413652s9.76241345 65.08275577-26.03310385 81.35344422C138.07380397 713.21069665 115.29484051 755.51448894 115.29484051 791.31000431V843.37621007a32.54137884 32.54137884 0 0 0 32.54137692 32.54137693h650.82756516a32.54137884 32.54137884 0 0 0 32.54137692-32.54137693v-48.81206729c0-29.28724036-16.27068846-94.36999612-231.04378456-175.72344225z",
        "p-id": "642"
      }
    }
  ]
})
    }
  